// extracted by mini-css-extract-plugin
export default {"content":"Sidebar_content__gtVll","wrapper":"Sidebar_wrapper__IBCXN","closeButton":"Sidebar_closeButton__a4Slj"};